<template>
  <div>
    <b-row class="mb-1">
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <div class="d-flex align-items-center">
          <b-link
            style="font-size: 26px; color: #fff;"
            :to="{ path: `/analytic-sub?DeptID=${deptid}`}"
          >
            <feather-icon
              style="margin-bottom: 5px;"
              size="26"
              icon="ArrowLeftIcon"
            /><span style="color: #00FF80;"> ลำโพง : </span>{{ detail }}
          </b-link>
          <a
            :href="anydesk"
            class="large-dropdown ml-1 ms-3"
          >
            <b-button
              size="sm"
              variant="outline-danger"
            ><b-img
              src="@/assets/images/logo/anydesk.png"
              style="height: 16px; width: 16px;"
            />
            <!-- <span style="color:#fff;"> {{ anydesk1 }}</span> -->
            </b-button>
          </a>
        </div>
      </b-col>
    </b-row>

    <b-col
      lg="12"
      md="12"
      sm="12"
    >
      <l-map
        ref="mymap"
        :zoom="zoom"
        :center="center"
        :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
        style="width: 100%; height: 572px; z-index: 0"
      >
        <l-tile-layer :url="url" />
        <!-- <l-marker
          :lat-lng="markers"
          :options="{ autoClose: false, closeOnClick: false }"
          @click="getInfoCount(marker.WayID, marker.detail, marker.wid)"
        >
          <l-icon
            :icon-size="[28, 40]"
            :icon-anchor="[16, 37]"
            :icon-url="require('@/assets/images/icons/detection/detectiony.svg')"
          />
        </l-marker> -->
        <l-marker
          v-for="(marker, index) in markers"
          :key="'marker'+index"
          :ref="'marker'+index"
          :lat-lng="[marker.latitude, marker.longitude]"
          :options="{ autoClose: false, closeOnClick: false }"
          @click="getInfoCount(marker.pole, marker.status, marker.lastupdate)"
        >
          <l-icon
            :icon-size="[28, 40]"
            :icon-anchor="[16, 37]"
            :icon-url="require('@/assets/images/icons/speaker1.png')"
          />
          <l-popup
            ref="popup"
          >
            <b-table
              class="table table-borderless"
              style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
              responsive="lg"
              :items="itemsCount"
              :fields="fields"
              small
              stacked
              foot-clone
            >
              <template #cell(status)="data">
                <b-badge :variant="status[1][data.value]">
                  {{ status[0][data.value] }}
                </b-badge>
              </template>
            </b-table>
          </l-popup>
        </l-marker>
      </l-map>
    </b-col>
    <b-col
      class="mt-1"
      lg="12"
    >
      <AnalyticSpeakerStatistics />
    </b-col>

    <b-col
      class="mt-1"
      lg="12"
    >
      <AnalyticSpeaker-Table />
    </b-col>

    <Modal-AnalyticSpeaker-Table />
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BLink, BButton, BImg, BTable, BBadge,
} from 'bootstrap-vue'
import {
  LMap, LMarker, LIcon, LTileLayer, LPopup,
  // LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import Ripple from 'vue-ripple-directive'
import AnalyticSpeakerTable from './SpeakerTable.vue'
import AnalyticSpeakerStatistics from './SpeakerStatistics.vue'
import ModalAnalyticSpeakerTable from './ModalAnalyticSpeakerTable.vue'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BButton,
    BImg,
    BTable,
    BBadge,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    AnalyticSpeakerTable,
    AnalyticSpeakerStatistics,
    ModalAnalyticSpeakerTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 17,
      center: [0, 0],
      fields: [
        { key: 'detail', label: 'ตัวที่:', class: 'text-center' },
        {
          key: 'status',
          label: 'สถานะ',
          class: 'text-center',
        },
        { key: 'lastupdate', label: 'อัพเดตล่าสุด:', class: 'text-center' },
      ],
      deptid: '',
      detail: '',
      markers: [],
      itemsCount: [],
      anydesk: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      intruso: '',
      status: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
    }
  },
  created() {
  },
  mounted() {
    this.getdetailAnalyticSpeaker()
    this.getSpeakerMarker()
    this.getDataAnalyticSpeaker()
    this.interval = setInterval(() => {
      this.getdetailCrossWalk()
      this.getDataCrosswalkScifi()
    }, 300000)
  },
  methods: {
    getdetailAnalyticSpeaker() {
      axios
        .post('/detailCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.markers = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.deptid = response.data[0].deptid
          this.detail = response.data[0].detail
          this.anydesk = `anydesk:${response.data[0].anydesk}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSpeakerMarker() {
      axios
        .post('/getTableSpeaker', { wid: this.$route.query.wid })
        .then(response => {
          this.markers = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInfoCount(detail, status, lastupdate) {
      this.itemsCount = []
      this.itemsCount.push({
        detail,
        status,
        lastupdate,
      })
    },

    getDataAnalyticSpeaker() {
      axios.post('/valueIntruder', { wid: this.$route.query.wid })
        .then(response => {
          this.intruso = response.data[0].intruso
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.95);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}
.large-dropdown .dropdown-menu {
  min-width: 100px; /* Adjust width as needed */
  font-size: 12px; /* Smaller font size */
  padding: 5px; /* Smaller padding */
}
.large-dropdown .btn {
  padding: 0.25rem 0.5rem; /* Smaller button padding */
  font-size: 0.875rem; /* Smaller text on the dropdown button */
}
</style>
